import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { db } from "../../../firebase/firebase";
import { query, getDocs, collection, where, updateDoc } from "firebase/firestore";
import { QueryKeys } from "config/query-keys";
import { ApplicationPayloadInterface } from "../../jobs/dto";

const updateCandidateApplication = async ({ jobId, applicantId, status }: ApplicationPayloadInterface): Promise<void> => {
  try {
    const applicationsRef = collection(db, "applications");
    const applicationQuery = query(applicationsRef, where("jobId", "==", jobId), where("applicantId", "==", applicantId));

    const querySnapshot = await getDocs(applicationQuery);

    if (querySnapshot.empty) {
      console.error("No matching application found for jobId:", jobId, "and applicantId:", applicantId);
      return;
    }

    // todo: send message from application status from here


    const applicationDoc = querySnapshot.docs[0].ref;

    await updateDoc(applicationDoc, { status });

  } catch (error) {
    console.error("Error updating candidate application:", error);
    throw error;
  }
};

export const useUpdateCandidateApplication = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCandidateApplication,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.JOBS] });
    },
    onError: () => {
      notification.error({
        message: "Error",
        description: "Failed to update candidate's application status.",
      });
    },
  });
};
